module.exports = __webpack_public_path__ + "static/media/cut2.ba870400.webm";